import './AboutMapApp.less';
import React, {useState, useEffect} from 'react';
import __ from "../../../i18n";
import AspectContainer from "../../../components/aspect-container/AspectContainer";


export default function AboutMapApp({addresses}) {

    const [selectedAddressIndex, setSelectedAddressIndex] = useState(0);

    if (addresses.length === 0) {
        return null;
    }

    const selectedAddress = addresses[selectedAddressIndex];

    return <div className="about-map-app">
        <section className="text-section">
            <div className="section-viewport">
                <div className="heading decorated-heading">
                    <div className="title">{__('Find us at the address')}</div>
                    <div className="decor-line"/>
                </div>
                {
                    addresses.length > 1 &&
                    <div className="address-list">
                        <ol>
                            {
                                addresses.map((t, index) => <li
                                    key={t.name + ';' + index}
                                    title={t.label}
                                    onClick={() => setSelectedAddressIndex(index)}
                                    className={selectedAddressIndex === index ? 'selected' : ''}
                                >{t.name}</li>)
                            }
                        </ol>
                    </div>
                }
            </div>
        </section>
        <section className="map-section">
            <AspectContainer>
                <iframe
                    src={selectedAddress.map_embed_url}
                    frameBorder="0"
                    allowFullScreen=""
                />
            </AspectContainer>
        </section>
    </div>;
}
